/**
 * ThreadFollowupChips
 *
 * Owner directive 2026-08-11: recommendations in EVERY thread, not just empty
 * ones. This renders the personalized "what to say next" chips under the
 * latest Prest0n reply; clicking one sends the exact text as a normal user
 * message (via sendProgrammaticMessage), so a "Connect my <App> — …" chip
 * fires the in-chat one-click connect card like any typed connect request.
 *
 * Pure render twin of WelcomeStarterChips (same StarterChip look, native
 * <button> chips → keyboard-activatable for free); the WHEN lives in
 * services/threadRecommendations/followupVisibility (shouldShowFollowupChips)
 * so the rule — including the gated-group-thread suppression — unit-tests
 * without mounting the chat system.
 */

import React from 'react';
import { StarterChipRow, StarterChip } from './styles';

export const ThreadFollowupChips: React.FC<{
  suggestions: readonly string[];
  /** Called with the EXACT chip text (already grounded + mention-prefixed). */
  onPick: (text: string) => void;
  disabled?: boolean;
}> = ({ suggestions, onPick, disabled }) => {
  if (!suggestions || suggestions.length === 0) return null;
  return (
    <StarterChipRow
      role="group"
      aria-label="Suggested next messages"
      data-testid="thread-followup-chips"
    >
      {suggestions.map((text, i) => (
        <StarterChip
          key={`${i}:${text}`}
          type="button"
          disabled={disabled}
          title={text}
          data-followup-prompt={text}
          onClick={() => {
            if (!disabled) onPick(text);
          }}
        >
          {text}
        </StarterChip>
      ))}
    </StarterChipRow>
  );
};

export default ThreadFollowupChips;
